'use client'

import { useEffect, useState } from 'react'

/**
 * The WebView's viewport stays full-height when the native keyboard opens, so there's no resize
 * event to react to — the app sends this intent instead so we know how much space it covers.
 */
export function useNativeKeyboardHeight(isInWebView: boolean): number {
  const [height, setHeight] = useState(0)

  useEffect(() => {
    if (!isInWebView) return

    function onMessage(event: MessageEvent) {
      try {
        const data = JSON.parse(event.data)

        if (data?.intent !== 'KEYBOARD_HEIGHT_CHANGED') {
          return
        }

        setHeight(Number(data.payload?.height) || 0)
      } catch {
        // Not a native intent message, ignore
      }
    }

    window.addEventListener('message', onMessage)

    return () => window.removeEventListener('message', onMessage)
  }, [isInWebView])

  return height
}
